import { useSelector } from 'react-redux';
import { isMinTariffsWithAds, minTariffsWithAdsMobile } from 'reactApp/appHelpers/featuresHelpers/features/minTariffsWithAds';
import { isPaidUserPrices } from 'reactApp/appHelpers/featuresHelpers/features/paidUserPrices';
import {
    isAllowedPriceDiffOverquota,
    isPriceDifferentiation,
    priceDiffTariffsMobile,
} from 'reactApp/appHelpers/featuresHelpers/features/priceDifferentiation';
import { useOverquotaSpecificTariffs } from 'reactApp/appHelpers/featuresHelpers/features/tariffOverquotaList';
import { UserSelectors } from 'reactApp/modules/user/user.selectors';
import { isCloudOrMailOrApiOverQuota } from 'reactApp/modules/userQuota/overquota.helpers';
import {
    getMinTariffsWithAdsMobile,
    getOverquotaTariffsList,
    getPriceDiffTariffsMobile,
    getTariffListPaidUsers,
    getTariffListPaidUsersMobile,
    getTariffsList,
} from 'reactApp/sections/QuotaLanding/TariffsPlans/TariffsPlans.selectors';
import type { RootState } from 'reactApp/store';

interface Props {
    isMobile: boolean;
    minTariff?: number;
    forceFamilyTariffFromQuery: boolean;
}

export const useGetTariffList = ({ isMobile, minTariff, forceFamilyTariffFromQuery }: Props) => {
    const isPaid = useSelector(UserSelectors.isPaidUser);
    const isOverQuotaUser = useSelector(isCloudOrMailOrApiOverQuota);
    const isCorp = useSelector(UserSelectors.isCorpUser);

    return useSelector((state: RootState) => {
        // tempexp_19870-start
        if (
            !isCorp &&
            !isPaid &&
            (!isOverQuotaUser || (isAllowedPriceDiffOverquota && isOverQuotaUser)) &&
            isPriceDifferentiation &&
            isMobile &&
            priceDiffTariffsMobile &&
            priceDiffTariffsMobile?.year?.length === priceDiffTariffsMobile?.month?.length
        ) {
            return getPriceDiffTariffsMobile(state);
        }
        // tempexp_19870-end

        // tempexp_19902-start
        if (
            isMobile &&
            isMinTariffsWithAds &&
            minTariffsWithAdsMobile &&
            minTariffsWithAdsMobile?.year?.length === minTariffsWithAdsMobile?.month?.length
        ) {
            return getMinTariffsWithAdsMobile(state);
        }
        // tempexp_19902-end

        // tempexp_19495-start
        if (isOverQuotaUser && useOverquotaSpecificTariffs) {
            return getOverquotaTariffsList(state, isMobile);
        }
        // tempexp_19495-end
        // tempexp_17380-next-line // tempexp_17815-next-line
        if (isPaidUserPrices) {
            return isMobile ? getTariffListPaidUsersMobile(state) : getTariffListPaidUsers(state);
        }
        return getTariffsList(state, isMobile, minTariff, forceFamilyTariffFromQuery, false);
    });
};
